import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import {
  commandWorkspaceWorkspacesList,
  commandWorkspaceRevokePermission,
  commandWorkspaceCollaboratorSummary,
} from 'containers/ConnectionManager/actions';

import meShape from 'Workspace/types/me';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import {
  PageWrapper,
  PageViewport,
  PageActions,
  PageActionsRight,
  PageContent,
} from 'components/PageStyles';
import {
  Grid,
  GridCell,
} from 'components/LayoutGrid';
import CollaboratorsSummaryProvider from 'Workspace/containers/CollaboratorsSummaryProvider';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import Sidebar from 'Workspace/components/WorkspaceSidebar';
import { selectWorkspacesList, selectWorkspaceCollaborators } from 'Workspace/Admin/store/selectors';
import gtmService from 'utils/gtm/gtmService';
import workspaceShape from 'Workspace/types/workspace';

import WorkspaceCard from 'Workspace/Admin/components/WorkspacesPage/components/WorkspaceCard';
import enhanceWithImmutable from 'hocs/enhanceWithImmutable';
import OwnerNavigation from '../OwnerNavigation';
import { isCardOwner } from '../../utils';
import messages from '../messages';
import { pageName, GTM_EVENT_TYPES } from 'utils/gtm/constants';

const WorkspacesPage = ({ getWorkspaces, revokePermission, workspacesList, location, me }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    getWorkspaces();
    setUser(me);
  }, [getWorkspaces, me]);

  /**
 * Telemetry init
 */
  useEffect(() => {
    (() => {
      gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: pageName.OWNER_WORKSPACES_PAGE } });
    })();
  }, [location]);

  return (<PageWrapper>
    <Sidebar navigation={<OwnerNavigation selectedKey={'workspaces'} />} />
    <PageViewport>
      <WorkspaceHeader title={intl.formatMessage(messages.workspaces)} />
      <PageActions>
        <PageActionsRight>
        </PageActionsRight>
      </PageActions>
      <PageContent>
        <Grid>
          {
            workspacesList &&
            workspacesList.map((workspace) => (

              <CollaboratorsSummaryProvider
                id={workspace.id}
                key={workspace.id}
                fetchCollaboratorsCommand={commandWorkspaceCollaboratorSummary}
                collaboratorsSelector={selectWorkspaceCollaborators}
                render={(collaborators) => isCardOwner(collaborators, user) && (
                  <GridCell key={`${workspace.id}cell`} span={{ desktop: 4, tablet: 6, mobile: 12 }} ><WorkspaceCard
                    key={workspace.id}
                    id={workspace.id}
                    name={workspace.name}
                    collaborators={collaborators}
                    onRevoke={(account) => revokePermission(workspace.id, account.id, account.type)}
                  />
                  </GridCell>
                )}
              />
            ))
          }
        </Grid>
      </PageContent>
    </PageViewport>
  </PageWrapper>);
};
const mapDispatchToProps = (dispatch) => ({
  getWorkspaces: () => dispatch(commandWorkspaceWorkspacesList()),
  revokePermission: (workspaceId, id, collaboratorType) => 
    dispatch(commandWorkspaceRevokePermission(workspaceId, id, collaboratorType)),
  getWSSummary: (workspaceId) => dispatch(commandWorkspaceCollaboratorSummary(workspaceId)),
  getCurrentUser: (state) => selectCurrentMe(state),
});

const mapStateToProps = (state, workspace) => ({
  workspacesList: selectWorkspacesList(state),
  summaries: selectWorkspaceCollaborators(state),
  collaborators: selectWorkspaceCollaborators(state, workspace.id),
  me: selectCurrentMe(state),
});

WorkspacesPage.propTypes = {
  getWorkspaces: PropTypes.func,
  revokePermission: PropTypes.func,
  workspacesList: PropTypes.arrayOf(workspaceShape),
  location: PropTypes.object,
  me: meShape,
};
export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithImmutable(WorkspacesPage));
